// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__dwsus","left":"StickyBox_left__To8Aw","right":"StickyBox_right__1Gxq-"};